import { useEffect, useState } from "react";
import { getPublishedArticles } from "../services/publicContent.service";
import type { PublishedArticleCard } from "../types/content.types";
import { usePublicServerData } from "../context/PublicServerDataContext";
import { useLocale } from "@/shared/i18n/locale";

export function usePublishedArticles() {
  const serverData = usePublicServerData();
  const locale = useLocale();
  const serverArticles = serverData?.articles;
  const initialArticles = (serverData?.locale ?? "pt") === locale ? (serverArticles ?? []) : [];
  const [articles, setArticles] = useState<PublishedArticleCard[]>(() => initialArticles);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    let isMounted = true;
    setIsLoading(true);

    getPublishedArticles(locale)
      .then((publishedArticles) => {
        if (isMounted) {
          setArticles(publishedArticles);
        }
      })
      .catch(() => {
        if (isMounted && !serverArticles) {
          setArticles([]);
        }
      })
      .finally(() => {
        if (isMounted) {
          setIsLoading(false);
        }
      });

    return () => {
      isMounted = false;
    };
  }, [serverArticles, locale]);

  return { articles, isLoading };
}
